export default __webpack_public_path__ + "static/img-project-2-422a6d6777d6ad56b12c51d90114d38f.png";